export default {
  'tasks.general.form.description': 'Service Description',
  'tasks.general.form.temporaryCode': 'Temporary Code',
  'tasks.general.form.area': 'Area',
  'tasks.general.form.KMManager': 'KM Manager',
  'tasks.general.form.time': 'Time',
  'tasks.general.form.unity': 'Unity',
  'tasks.general.form.lifespanDay': 'Lifespan (days)',
  'tasks.general.form.observation': 'Observations',
  'tasks.general.form.button.remove': 'Remove',
  'tasks.general.form.button.save': 'Save',
  'tasks.modal.remove.title': 'Remove Service',
  'tasks.modal.remove.content': 'Do you want to remove the task',
  'tasks.modal.remove.button.ok': 'Remove',
  'tasks.modal.remove.message.success': 'Service removed successfully!',
  'tasks.modal.remove.message.error': 'Unable to remove task!',
  'tasks.page.button.generateReport': 'Generate report',
  'tasks.page.button.changePrices': 'Change Prices',
  'tasks.page.button.newTask': 'New Service',
  'tasks.general.companies.price': 'Price by Companies',
  'tasks.general.companies.price.list.name': 'Company',
  'tasks.general.companies.price.list.amountTime': 'Value/Time',
  'tasks.general.companies.price.list.amount': 'Amount',
  'tasks.report.form.area': 'Area',
  'tasks.report.form.company': 'Company',
  'tasks.report.form.date': 'Start/End Date',
  'tasks.changePrices.modal.title': 'Chenge Prices',
  'tasks.changePrices.modal.message.success': 'Prices changed successfully!',
  'tasks.changePrices.modal.message.error':
    'It was not possible to change prices!',
  'tasks.changePrice.form.type.all': 'All Services',
  'tasks.changePrice.form.type.area': 'By Area',
  'tasks.changePrice.form.company': 'Select a Company',
  'tasks.changePrice.form.area': 'Select a Area',
  'tasks.changePrice.form.typeValue.value': 'By Value',
  'tasks.changePrice.form.typeValue.percent': 'By Percentage',
  'tasks.changePrice.form.price': 'Price',
  'tasks.form.description': 'Task Description',
  'tasks.form.temporaryCode': 'Temporary Code',
  'tasks.form.area': 'Area',
  'tasks.form.maintenanceKm': 'Maintenance Km',
  'tasks.form.nbsCode': 'NBS',
  'tasks.form.maintenanceTime': 'Maintenance Time',
  'tasks.form.unit': 'Unit',
  'tasks.form.unit.validator.max': 'Unit should have only 2 characters',
  'tasks.form.time': 'Time',
  'tasks.form.lifeSpan': 'Life Span',
  'tasks.form.note': 'Notes',
  'tasks.form.taskPrices': 'Task Price',
  'tasks.form.taskPrices.company': 'Company',
  'tasks.form.taskPrices.price': 'Price (US$)',
  'tasks.form.taskPrices.fixedServiceCost': 'Fixed Service Cost',
  'tasks.form.taskPrices.commissionPercentage': '(%) Commission',
  'tasks.create.notification.success': 'Success',
  'tasks.create.notification.successDescription': 'Task created.',
  'tasks.create.notification.error': 'Error',
  'tasks.create.notification.errorDescription': 'Error creating task',

  'tasks.update.notification.success': 'Success',
  'tasks.update.notification.successDescription': 'Task updated.',

  'tasks.remove': 'Remove Task',
  'tasks.remove.alert': 'Do you really want to remove the task:',
  'tasks.remove.notification.success': 'Success',
  'tasks.remove.notification.successDescription': 'Task removed.',

  'tasks.modal.report.title': 'Generate Report',
  'tasks.modal.report.buttons.viewReport': 'View Report',
  'tasks.modal.report.buttons.pdf': 'Generate PDF',
  'tasks.modal.report.buttons.rtf': 'Generate RTF',
  'tasks.modal.report.buttons.csv': 'Generate CSV',
  'tasks.modal.report.form.description': 'Description',
  'tasks.modal.report.form.descriptionUpUntil': 'Until',
  'tasks.modal.report.form.area': 'Area',
  'tasks.modal.report.form.time': 'Time',
  'tasks.modal.report.form.timeUpUntil': 'Until',
  'tasks.modal.report.form.companies': 'Companies',

  'tasks.application.list.header.automaker': 'Automaker',
  'tasks.application.list.header.model': 'Model',
  'tasks.application.list.header.time': 'Time',
  'tasks.application.modal.create.success.title': 'Success!',
  'tasks.application.modal.create.success.description':
    'Service application successfully created',
  'tasks.application.modal.remove.success.description':
    'Application removed successfully',
  'tasks.application.modal.update.success.description':
    'Application update successfully',

  'task.list.action.button': 'View/Edit',
  'task.list.action.DeleteButton.remove': 'Remove',

  'task.application.form.automaker': 'Automaker',
  'task.application.form.model': 'Model',
  'task.application.form.modelVersion': 'Model Version',
  'task.application.form.time ': 'Time',
  'task.application.form.add': 'Add',

  'task.application.vehicles.create': 'Create',
  'task.application.modal.addApplication': 'Add Aplication',

  'task.status.message.success': 'Service Status Changed Successfully!',
};
